const getEnabledEmails = (): string[] => {
  const envEmails = process.env.REACT_APP_BENCHMARK_ENABLED_EMAILS ?? "";
  return envEmails.split(",").map(email => email.trim().toLowerCase()).filter(Boolean);
};

export const isBenchmarkEnabledForCountry = (countryCode: string | undefined, email?: string): boolean => {
  const enabledEmails = getEnabledEmails();
  const normalisedEmail = email?.trim().toLowerCase();

  if (normalisedEmail && enabledEmails.includes(normalisedEmail)) {
    return true;
  }

  if (!countryCode) return false;

  const enabledCountries = process.env.REACT_APP_BENCHMARK_ENABLED_COUNTRIES;
  if (!enabledCountries) return false;

  const allowedCountries = enabledCountries.split(",").map(c => c.trim().toUpperCase());
  return allowedCountries.includes(countryCode.toUpperCase());
};